
// import React, { useState } from 'react';
// import { FaUtensils, FaShoppingBasket } from "react-icons/fa";


// const ServiceModeToggle = () => {
//   const [activeMode, setActiveMode] = useState('restaurants');

//   const modes = [
//   { 
//     id: 'restaurants', 
//     label: 'مطاعم',
//     icon: <FaUtensils size={20} />
//   },
//   { 
//     id: 'market', 
//     label: 'ماركت',
//     icon: <FaShoppingBasket size={20} />
//   }
// ];

//   const handleModeChange = (modeId) => {
//     setActiveMode(modeId);
//   };

//   return (
//     <div className="w-full py-3  px-4 lg:px-8">
//       <div className="service-mode-toggle">
//         {modes?.map((mode) => (
//           <button
//             key={mode?.id}
//             className={`service-mode-button ${activeMode === mode?.id ? 'active' : ''}`}
//             onClick={() => handleModeChange(mode?.id)}
//           >
//             <span className="flex items-center justify-center gap-2 py-0 ">

//               {mode?.icon}
//                {mode?.label}

//             </span>
//           </button>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default ServiceModeToggle;
// import React from 'react';
// import { FaUtensils, FaShoppingBasket } from "react-icons/fa";
// import { useNavigate, useLocation } from 'react-router-dom';

// const ServiceModeToggle = () => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const modes = [
//     {
//       id: 'restaurants',
//       label: 'مطاعم',
//       icon: <FaUtensils size={20} />,
//       routes: ['/restaurant-home-page', '/restaurants']
//     },
//     {
//       id: 'market',
//       label: 'ماركت',
//       icon: <FaShoppingBasket size={20} />,
//       routes: ['/market-home-page','/markets']
//     }
//   ];

//   const handleModeChange = (route) => {
//     if (location.pathname !== route) {
//       navigate(route);
//     }
//   };

//   return (
//     <div className="w-full py-2 px-4 lg:px-8">
//       <div className="service-mode-toggle flex gap-4">
//         {modes.map((mode) => (
//           <button
//             key={mode.id}
//             className={`${mode.id === "market" ? "service-mode-button2" : "service-mode-button"} ${mode.routes.some(r => location.pathname.startsWith(r)) ? 'active' : ''
//               }`}
//             onClick={() => handleModeChange(mode.routes[0])} 
//           >
//             <span className="flex items-center justify-center gap-2 py-0">
//               {mode.icon} {mode.label}
//             </span>
//           </button>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default ServiceModeToggle;
import React from 'react';
import { FaUtensils, FaShoppingBasket } from "react-icons/fa";
import { useNavigate, useLocation } from 'react-router-dom';

const ServiceModeToggle = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const modes = [
    {
      id: 'restaurants',
      label: 'مطاعم',
      icon: <FaUtensils size={18} />,
      routes: ['/restaurant-home-page', '/restaurants'],
      color: 'orange'
    },
    {
      id: 'market',
      label: 'ماركت',
      icon: <FaShoppingBasket size={18} />,
      routes: ['/market-home-page','/markets'],
      color: 'green'
    }
  ];

  const handleModeChange = (route) => {
    if (location.pathname !== route) {
      navigate(route);
    }
  };

  return (
    <div className="w-full py-2 px-4 lg:px-8">
      <div className="flex gap-3 flex-wrap">

        {modes.map((mode) => {
          const isActive = mode.routes.some(r =>
            location.pathname.startsWith(r)
          );

          return (
           <button
  key={mode.id}
  onClick={() => handleModeChange(mode.routes[0])}
  className={`${mode.id === "market" ? "service-mode-button2" : "service-mode-button"} 
  ${mode.routes.some(r => location.pathname.startsWith(r)) ? 'active' : ''} 
  flex items-center justify-center gap-2`}
>
  {mode.icon}
  <span>{mode.label}</span>
</button>
          );
        })}

      </div>
    </div>
  );
};

export default ServiceModeToggle;